/* template */
<template><mpx-view :style="[(itemStyle)] | transRpxStyle" @tap="handleClick" class="swipe-item"><div :style='[("backgroundImage : url("+(item)+")"),(imageStyle)] | transRpxStyle' class="image"/></mpx-view></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"mae280c76"}'>
  .swipe-item
    position relative
    display flex
    justify-content center
    align-items center
    .image
      height 100%
      width 100%
      background-repeat no-repeat
      background-size 100% 100%
      background-position center
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "mae280c76"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./ts-web-swiper-item.mpx.js?isComponent&outputPath=components%2Fts-web-swiper-itemae280c76%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./ts-web-swiper-item.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fts-web-swiper-itemae280c76%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["mae280c76"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/ts-web-swiper-itemae280c76/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
